// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const useCategoriesApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getCategories = () => request("GET", `${API_STAGES_URL}/v1/categories`)

  return [
    requestState,
    payload,
    error,
    {
      getCategories,
    },
  ]
}

export default useCategoriesApi
